import { render, staticRenderFns } from "./HandlingOfSpares.vue?vue&type=template&id=71ce4af0&"
import script from "./HandlingOfSpares.vue?vue&type=script&lang=js&"
export * from "./HandlingOfSpares.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports